import React, { useState, useEffect } from "react";
import "./Slidermodule.css";

const Slider = ({
  paginatedData,
  numPostsToShow,
  showImgToggler,
  showPostTitle,
  showMeta,
  showContent,
  contentType,
  truncateContent,
  wordsLimit,
  imageUrl,
  valueForWidth,
  widthPercentage,
  widthController,
  ImgWidth,
  height,
  ReadMoreBgColor,
  showReadMoreToggler,
  ReadMoreTextColor,
  button_Top_bottom_Padding,
  button_Right_Left_Padding,
  title_font_size,
  Meta_font_size,
  Content_font_size,
  Read_more_font_size,
  customCSS,
  __,
  Content_Manage_styling,
  title_Manage_styling,
  Meta_Manage_styling,
  ReadMoreText,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = paginatedData.slice(0, numPostsToShow);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="wep-root">
      <div className="slider-container">
        <div className="slider">
          {customCSS && <style>{customCSS}</style>}
          {slides.map((item, index) => {
            const formattedDate = new Date(item?.date).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
              }
            );

            const featuredImgExist =
              item.featured_image_url &&
              typeof item.featured_image_url === "object" &&
              Object.keys(item.featured_image_url).length > 0;

            return (
              <div
                key={item.id}
                className={`slide ${index === currentIndex ? "active" : ""}`}
                style={{ display: index === currentIndex ? "block" : "none" }}
              >
                <div className="wep-card">
                  {
                    item.featured_image_url &&
                    featuredImgExist && (
                      <div className="wep-card-img">
                        <img
                          src={item.featured_image_url[imageUrl]}
                          alt={item.title.rendered} // Added alt text for accessibility
                        />
                      </div>
                    )}
                  <div className="wep-card-body">
                    <div className="wep-card-heading">
                      {showPostTitle && (
                        <h4
                          className="wep-card-title"
                          style={{
                            ...(title_Manage_styling && {
                              fontSize: title_font_size,
                            }),
                          }}
                        >
                          <a
                            href={item.link}
                            dangerouslySetInnerHTML={{
                              __html: item.title.rendered,
                            }}
                          />
                        </h4>
                      )}

                      {showMeta && (
                        <div
                          className="meta-data"
                          style={{
                            ...(Meta_Manage_styling && {
                              fontSize: Meta_font_size,
                            }),
                          }}
                        >
                          {formattedDate && `${formattedDate} `}
                          {item.post_author && `| Author: ${item.post_author} `}
                          {item.assigned_categories &&
                            `| Categories: ${item.assigned_categories} `}
                        </div>
                      )}
                    </div>
                    {showContent && (
                      <div
                        className="wep-card-text"
                        style={{
                          ...(Content_Manage_styling && {
                            fontSize: Content_font_size,
                          }),
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            contentType === "Full-Post"
                              ? item.content.rendered
                              : !item.excerpt?.rendered
                              ? truncateContent(
                                  item.content.rendered,
                                  wordsLimit
                                )
                              : truncateContent(
                                  item.excerpt.rendered,
                                  wordsLimit
                                ),
                        }}
                      />
                    )}
                  </div>
                  <div className="wep-card-footer">
                    <a
                      href={item.link}
                      target="_blank"
                      className="wep-btn wep-btn-primary"
                      style={{
                        ...(showReadMoreToggler && {
                          "--wep-btn-bg": ReadMoreBgColor,
                          "--wep-btn-hover-bg": `color-mix(in srgb, ${ReadMoreBgColor}, black 20%)`,
                          "--wep-btn-color": ReadMoreTextColor,
                          "--wep-btn-hover-color": ReadMoreTextColor,
                          "--wep-btn-padding-y": button_Top_bottom_Padding,
                          "--wep-btn-padding-x": button_Right_Left_Padding,
                          "--wep-btn-font-size": Read_more_font_size,
                        }),
                      }}
                    >
                      {__(ReadMoreText || 'Read More', "advanced-posts-listing")}
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <button className="slider-button prev" onClick={prevSlide}>
          ❮
        </button>
        <button className="slider-button next" onClick={nextSlide}>
          ❯
        </button>
      </div>
    </div>
  );
};

export default Slider;
